import { EnvironmentData, WorkspaceData } from '~/api';
import { shouldShowBillingBanner } from '~/pages/Billing/utils.ts';

const TRANSLATION_BASE_PATH = `pages.header`;

const getTranslationKey = (translationStr: string): string =>
  `${TRANSLATION_BASE_PATH}.${translationStr}`;

const shouldShowInProductBanner = ({
  environment,
  workspace
}: {
  workspace: WorkspaceData;
  environment: EnvironmentData;
}) => {
  return shouldShowBillingBanner({
    environment,
    workspace
  });
};

export { getTranslationKey, shouldShowInProductBanner };
